import { Routes, Route } from 'react-router-dom';
import LoginPage from '@/pages/LoginPage';
import { ProtectedRoute } from '@/auth/ProtectedRoute';
import NotFoundPage from '@/pages/errors/NotFoundPage';
import AccessDeniedPage from '@/pages/errors/AccessDeniedPage';
import InternalServerErrorPage from '@/pages/errors/InternalServerErrorPage';
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import AppLayout from '@/layout/AppLayout';
import Dashboard from '@/pages/Dashboard';
import RankingPage from '@/pages/Ranking/RankingComputersPage';
import CoreStockManagerPage from "@/pages/CoreStockManagerPage";
import AssetComposerPage from "@/pages/AssetComposerPage";
import SystemSettingsPage from "@/pages/SystemSettingsPage";
import SecretarySelectorPage from "@/pages/SecretarySelectorPage";
import ItemOutflowPage from "@/pages/ItemOutflowPage";
import CallPage from "@/pages/CallPage";
import CallListPage from "@/pages/CallListPage";
import CallDetailsPage from "@/pages/CallDetailsPage";
import CallProgressPage from "@/pages/CallProgressPage";
import ApplicantPage from "@/pages/ApplicantPage";
import AdministrationPage from '@/pages/AdministrationPage';
import ExternalRepairPage from '@/pages/ExternalRepairPage';
import ReportsPage from '@/pages/ReportsPage';
import ProfilePage from "@/pages/ProfilePage";

export default function AppRoutes() {
    return (
        <Routes>
            {/* --- ROTAS PÚBLICAS --- */}
            <Route path="/" element={<LoginPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />

            <Route element={<ProtectedRoute />}>
                <Route path="/select-secretary" element={<SecretarySelectorPage />} />
            </Route>

            <Route element={<ProtectedRoute requireSecretary />}>
                <Route element={<AppLayout />}>
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route element={<ProtectedRoute roles={['ADMIN','TECHNICAL_ADMIN','TECHNICAL','VIEWER','SYSTEM_EXTERNAL']} />}><Route path="/reports" element={<ReportsPage />} /></Route>
                    <Route path="/ranking" element={<RankingPage />} />
                    <Route path="/tickets" element={<CallListPage />} />
                    <Route path="/tickets/:id" element={<CallDetailsPage />} />
                    <Route element={<ProtectedRoute roles={['ADMIN', 'TECHNICAL_ADMIN', 'TECHNICAL']} />}>
                        <Route path="/external-repairs" element={<ExternalRepairPage />} />
                        <Route path="/external-repairs/new" element={<ExternalRepairPage />} />
                        <Route path="/asset-composer" element={<AssetComposerPage />} />
                        <Route path="/asset-composer/new" element={<AssetComposerPage />} />
                        <Route path="/asset-composer/:id/edit" element={<AssetComposerPage />} />
                        <Route path="/tickets/:id/edit" element={<CallPage />} />
                        <Route path="/tickets/new" element={<CallPage />} />
                        <Route path="/tickets/:id/progress" element={<CallProgressPage />} />
                        <Route path="/applicants" element={<ApplicantPage />} />
                        <Route path="/applicants/new" element={<ApplicantPage />} />
                        <Route path="/applicants/:id/edit" element={<ApplicantPage />} />
                    </Route>
                    <Route element={<ProtectedRoute roles={['ADMIN', 'TECHNICAL_ADMIN', 'TECHNICAL']} />}>
                        <Route path="/core-stock-manager" element={<CoreStockManagerPage />} />
                        <Route element={<ProtectedRoute roles={['ADMIN','TECHNICAL_ADMIN']} />}><Route path="/core-stock-manager/new" element={<CoreStockManagerPage />} /></Route>
                        <Route path="/core-stock-manager/:id/edit" element={<CoreStockManagerPage />} />
                        <Route path="/stock-outflow" element={<ItemOutflowPage />} />
                        <Route path="/stock-outflow/new" element={<ItemOutflowPage />} />
                    </Route>
                    <Route element={<ProtectedRoute roles={['ADMIN']} />}>
                        <Route path="/organization" element={<SystemSettingsPage key="organization" mode="organization" />} />
                        <Route path="/external-repairs/companies" element={<SystemSettingsPage key="companies" mode="companies" />} />
                        <Route path="/it-teams" element={<AdministrationPage module="teams" />} />
                        <Route path="/it-teams/new" element={<AdministrationPage module="teams" />} />
                        <Route path="/it-teams/:id/edit" element={<AdministrationPage module="teams" />} />
                        <Route path="/it-teams/:id" element={<AdministrationPage module="teams" />} />
                        <Route path="/inventory-centers" element={<AdministrationPage module="centers" />} />
                        <Route path="/inventory-centers/new" element={<AdministrationPage module="centers" />} />
                        <Route path="/inventory-centers/:id/edit" element={<AdministrationPage module="centers" />} />
                        <Route path="/inventory-centers/:id" element={<AdministrationPage module="centers" />} />
                        <Route path="/users" element={<AdministrationPage module="users" />} />
                        <Route path="/users/new" element={<AdministrationPage module="users" />} />
                        <Route path="/users/:id/edit" element={<AdministrationPage module="users" />} />
                        <Route path="/users/:id" element={<AdministrationPage module="users" />} />
                        <Route path="/system-settings" element={<SystemSettingsPage />} />
                    </Route>
                    <Route path="/profile" element={<ProfilePage />} />
                </Route>
            </Route>

            {/* --- PÁGINAS DE ERRO E FALLBACK --- */}
            <Route path="/403" element={<AccessDeniedPage />} />
            <Route path="/500" element={<InternalServerErrorPage />} />
            <Route path="*" element={<NotFoundPage />} />
        </Routes>
    );
}
